import createReducer from 'reducers/createReducer';

import { Menu } from 'actions/actionTypes';

import History from 'routes/history';

const INITIAL_STATE = {
    isAsideMenuOpen: false,
    isHamburgerMenuOpen: false,
    currentMenu: {
        menuIdx: 0,
        parentMenuIdx: 0,
        menuName: '',
        menuUrl: '',
        menuIcon: '',
        menuSort: 0,
        isExpand: false,
        subMenuList: [],
    },
    menuList: [],
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Menu.MOVE_MENU]: (state, action) => {
        state.currentMenu = action.payload;

        if (action.payload.menuUrl !== '') {
            History.push(action.payload.menuUrl);
        }
    },

    [Menu.RESET_MENU_LIST]: (state, action) => {
        state.currentMenu = INITIAL_STATE.currentMenu;
        state.menuList = INITIAL_STATE.menuList;
    },

    [Menu.CHANGE_CURRENT_MENU]: (state, action) => {
        state.currentMenu = action.payload.isCurrentMenu;
    },

    [Menu.CHANGE_ASIDE_MENU_OPEN]: (state, action) => {
        state.isAsideMenuOpen = action.payload.isAsideMenuOpen;
    },

    [Menu.HAMBURGER_MENU_OPEN]: (state, action) => {
        state.isHamburgerMenuOpen = action.payload.isHamburgerMenuOpen;
    },

    [Menu.LOAD_MENU_REQUEST]: (state, action) => {
        state.menuList = INITIAL_STATE.menuList;
        state.error = INITIAL_STATE.error;
    },
    [Menu.LOAD_MENU_SUCCESS]: (state, action) => {
        state.menuList = action.payload.menuList;
    },
    [Menu.LOAD_MENU_FAILURE]: (state, action) => {
        state.menuList = INITIAL_STATE.menuList;
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
